function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import * as httpProtocol from '@shared/services/http/httpProtocol';
import { Constants } from '@shared/utils/constants';
import { getAppConfig } from '@shared/services/init/appConfig';
import { logError } from '@shared/utils/httpClientUtil';
import { marketplaceLeadsApiVersion } from '@shared/specifics';
const marketplaceLeadsTimeoutInMs = 30000;
export function sendLead(payload, options) {
    return _sendLead.apply(this, arguments);
}
function _sendLead() {
    _sendLead = _async_to_generator(function*(payload, options) {
        try {
            const { requestId } = options || {};
            const endpoint = `${getAppConfig('marketplaceLeadsHost')}/api/leads`;
            const httpOptions = {
                requireCorrelationId: true,
                stringifyPostData: false,
                allowOrigin: true,
                authenticationType: httpProtocol.AuthenticationTypes.MarketplaceLeads,
                setBearerHeader: true,
                contentType: 'application/json',
                requestId,
                timeout: marketplaceLeadsTimeoutInMs
            };
            const post = httpProtocol.post(endpoint, httpOptions);
            return post.addQueryEntry(Constants.QueryStrings.apiVersion, marketplaceLeadsApiVersion).setData(payload).request();
        } catch (error) {
            logError('sendLead', error);
            throw error;
        }
    });
    return _sendLead.apply(this, arguments);
}
